import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import PersonSearchCivilUnionNonResidentNotificationShared from 'shell/components/shared/research-notifications/research-civil-union-non-resident/edit-person-search';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface PersonSearchCivilUnionNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const PersonSearchCivilUnionNonResidentNotificationCivilStatusShared = ({
  scope,
  items,
}: PersonSearchCivilUnionNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <PersonSearchCivilUnionNonResidentNotificationShared
        redirectUrl={redirectUrl}
        goBackUrl={`${goBackUrl}/unione-civile/non-residenti`}
        items={items}
      />
    </Fragment>
  );
};

PersonSearchCivilUnionNonResidentNotificationCivilStatusShared.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonSearchCivilUnionNonResidentNotificationCivilStatusShared;
